module.exports = __webpack_public_path__ + "img/explain_3.fd5a476b.png";